export { default } from './AislesMenu';
